export const getBrowserTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone
